import styled from 'styled-components';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 0;
`;

export const SuccessBox = styled.div`
  text-align: center;
  padding: 24px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const SuccessTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
`;

export const SuccessDesc = styled.div`
  font-size: 14px;
  color: #475569;
  line-height: 1.5;
  margin: 0;
`;
